import { useState } from 'react';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ContactPopup from './ContactPopup';

const PricingTableInsurance = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const plans = [
    {
      name: 'Defense Only',
      price: 'Starter Protection',
      subtext: 'Best for new brands and small businesses testing the market.',
      features: [
        'Coverage for defending certain trademark infringement claims (limits apply)',
        'Access to IP-focused legal counsel through the insurer\'s panel (where available)',
        'Designed for early-stage businesses on a budget'
      ],
      note: 'Premium depends on industry, coverage limits, and portfolio size',
      cta: 'Get IP Insurance Quote'
    },
    {
      name: 'Enforcement Only',
      price: 'Growth Protection',
      subtext: 'For growing brands with more exposure and higher risk.',
      features: [
        'Funding to pursue infringers of your mark',
        'Offensive litigation costs covered',
        'Cease & desist letter support',
        'Infringement investigation costs',
        'Coverage for enforcement actions'
      ],
      note: 'Premium depends on industry, coverage limits, and portfolio size',
      cta: 'Get IP Insurance Quote'
    },
    {
      name: 'Comprehensive',
      price: 'Premium Protection',
      subtext: 'For established brands that cannot afford downtime.',
      popular: true,
      features: [
        'Comprehensive defence and enforcement coverage with higher limits',
        'Coverage for damages and certain indemnity obligations, depending on policy',
        'Designed to protect brand value, investor confidence, and long-term growth'
      ],
      note: 'Premium depends on industry, coverage limits, and portfolio size',
      cta: 'Get IP Insurance Quote'
    }
  ];

  return (
    <>
      <section className="py-20 bg-primary-600" data-testid="pricing-insurance-section">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">Choose Your Coverage</h2>
            <p className="text-xl text-white">Trademark insurance tailored to your risk profile</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {plans.map((plan, idx) => (
              <div
                key={idx}
                className={`bg-white rounded-2xl p-8 shadow-lg relative flex flex-col ${
                  plan.popular ? 'ring-4 ring-primary-100 transform scale-105' : ''
                } card-hover`}
                data-testid={`pricing-insurance-plan-${plan.name.toLowerCase().replace(' ', '-')}`}
              >
                {/* {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-secondary-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
                    Recommended
                  </div>
                )} */}
                
                <div className="text-center mb-6">
                  {/* <h3 className="text-2xl font-bold mb-2">{plan.name}</h3> */}
                  <div className="flex items-baseline justify-center mb-2">
                    <span className="text-4xl font-bold gradient-text">{plan.price}</span>
                  </div>
                  <p className="text-sm text-secondary-600 text-left">{plan.subtext}</p>
                </div>

                <div className="space-y-3 mb-6 flex-grow max-h-80 overflow-y-auto">
                  {plan.features.map((feature, featureIdx) => (
                    <div key={featureIdx} className="flex items-start space-x-2">
                      <Check className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#ff4d1b' }} />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* <p className="text-xs text-gray-500 mb-6 text-center">{plan.note}</p> */}

                <Button
                  onClick={() => setIsPopupOpen(true)}
                  className={`w-full py-3 rounded-full font-semibold mt-auto ${
                    plan.popular
                      ? 'bg-secondary-600 text-white'
                      : 'bg-white text-primary-600 border-2 border-primary-600 hover:bg-primary-50'
                  }`}
                  data-testid={`pricing-insurance-cta-${plan.name.toLowerCase().replace(' ', '-')}`}
                >
                  {plan.cta}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} redirectUrl="/ins-application-submitted" />
    </>
  );
};

export default PricingTableInsurance;
